import { TextWidget } from './textWidget'
import { NumberWidget } from './numberWidget'
import { CurrencyWidget } from './currencyWidget'
import { DateWidget } from './dateWidget'
import { EmailWidget } from './emailWidget'
import { CheckboxWidget } from './checkboxWidget'
import { RadioWidget } from './radioWidget'
import { TimeWidget } from './timeWidget'
import { DropdownWidget } from './dropdownWidget'
import { BankWidget } from './bankWidget'
import { AddressWidget } from './addressWidget'
import { DatabaseWidget } from './databaseWidget'
import { CnaeWidget } from './cnaeWidget'
import { CpfWidget } from './CpfWidget'
import { CnpjWidget } from './CnpjWidget'
import { SeparatorWidget } from './separatorWidget'
import { StructuredListWidget } from './structuredListWidget'
import { PersonWidget } from './personWidget'
import { TetxDatabaseWidget } from './textDatabaseWidget'
import { ImageWidget } from './imageWidget'
import { ParagraphCkeditorWidget } from './paragraphCkeditorWidget'
import { DescriptionWidget } from './descriptionWidget'
import { AttachmentWidget } from './attachmentWidget'
import { ApiWidget } from './apiWidget'
import { InternalInternalDatabaseWidget } from './InternalDatabase'

export const widgets = {
	text: TextWidget,
	currency: CurrencyWidget,
	number: NumberWidget,
	cpf: CpfWidget,
	cnpj: CnpjWidget,
	date: DateWidget,
	email: EmailWidget,
	checkbox: CheckboxWidget,
	radio: RadioWidget,
	time: TimeWidget,
	dropdown: DropdownWidget,
	bank: BankWidget,
	address: AddressWidget,
	person: PersonWidget,
	database: DatabaseWidget,
	cnae: CnaeWidget,
	separator: SeparatorWidget,
	structured_list: StructuredListWidget,
	text_database: TetxDatabaseWidget,
	variable_image: ImageWidget,
	attachment: AttachmentWidget,
	description: DescriptionWidget,
	text_area_ckeditor: ParagraphCkeditorWidget,
	api: ApiWidget,
	internal_database: InternalInternalDatabaseWidget,
}
